// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__s0GAk","hover":"Link_hover__02FWL","focus":"Link_focus__7MrPB","external":"Link_external___YuDB","underline":"Link_underline__Ixex1"};